export default __webpack_public_path__ + "static/mahditahavorgar201-d94f0c5b0bc37e2e62dc8befbe4f74ef.pdf";